var path = 'src/app/patients/navigation/patient-navigation.html';
var html = "<div ng-repeat=\"system in systems\" system-navigation patient=patient system=system></div> <div ng-repeat=\"cohort in cohorts\" cohort-navigation patient=patient cohort=cohort></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/patients/navigation/patient-navigation.html
// module id = 515
// module chunks = 0